import { Component, Input, OnInit } from '@angular/core';
import { UserRecommendation } from '../../../interfaces/user';

@Component({
  selector: 'app-tips-tile',
  templateUrl: './tips-tile.component.html',
  styleUrls: ['./tips-tile.component.scss']
})
export class TipsTileComponent implements OnInit {

  @Input() recommendation?: UserRecommendation;

  /** 'tile' is a card with a large image, 'highlight' and 'row' are rows in a list of tips, with a button or a round link */
  @Input() variant: 'tile' | 'highlight' | 'row' = 'tile';

  public image: string = "";

  public timestamp_diff = 2;

  constructor() { }

  ngOnInit(): void {

    let date1 = new Date(this.recommendation?.viewed ?? "");
    let date2 = new Date();
    let Difference_In_Time = date2.getTime() - date1.getTime();
    this.timestamp_diff = Math.round(Difference_In_Time / (1000 * 3600 * 24));

    this.image = this.recommendation?.recommendation?.img_url ?? "/";
  }
}
